import { Routes } from '@angular/router';
import { AdminLayoutComponent } from './shared/components/layouts/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from './shared/components/layouts/auth-layout/auth-layout.component';
import { AuthGuard } from './services/auth/auth.guard';

export const rootRouterConfig: Routes = [
    {
        path: '',
        redirectTo: 'brand',
        pathMatch: 'full',
        canLoad: [AuthGuard],
    },
    {
        path: '',
        component: AuthLayoutComponent,
        children: [
            {
                path: 'sessions',
                loadChildren: () => import('./sessions/sessions.module').then((m) => m.SessionsModule),
                data: { title: 'Session' },
            },
        ],
    },
    {
        path: '',
        component: AdminLayoutComponent,
        children: [
            {
                path: 'competition',
                loadChildren: () => import('./competition/competition.module').then((m) => m.CompetitionModule),
                data: { title: 'Competition', breadcrumb: 'Competition' },
                canActivate: [AuthGuard],
            },
            {
                path: 'therapeutic-areas',
                loadChildren: () =>
                    import('./therapeutic-area/therapeutic-area.module').then((m) => m.TherapeuticAreaModule),
                data: { title: 'Thereapeutic Area', breadcrumb: 'Therapeutic Area Dashboard' },
                canLoad: [AuthGuard],
            },
            {
                path: 'brand',
                loadChildren: () => import('./brand/brand.module').then((m) => m.BrandModule),
                data: { title: 'Brand', breadcrumb: 'Brand Dashboard' },
                canLoad: [AuthGuard],
            },
            {
                path: 'hub',
                loadChildren: () => import('./hub/hub.module').then((m) => m.HubModule),
                data: { title: 'Hub', breadcrumb: 'HUB' },
                canLoad: [AuthGuard],
            },
            {
                path: 'user',
                loadChildren: () => import('./user/user.module').then((m) => m.UserModule),
                data: { title: 'Profile', breadcrumb: 'PROFILE' },
                canLoad: [AuthGuard],
            },
            {
                path: 'video-conference',
                loadChildren: () =>
                    import('./video-conference/video-conference.module').then((m) => m.VideoConferenceModule),
                data: {
                    title: 'Auro-Space LIVE',
                    breadcrumb: 'Auro-Space  LIVE',
                },
                canLoad: [AuthGuard],
            },
            {
                path: 'admin',
                loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule),
                data: { title: 'Admin', breadcrumb: 'Admin' },
                canLoad: [AuthGuard],
            },

            {
                path: 'email',
                loadChildren: () => import('./email/email.module').then((m) => m.EmailModule),
                data: { title: 'Email', breadcrumb: 'Email' },
                canLoad: [AuthGuard],
            },
            {
                path: 'cpd',
                loadChildren: () => import('./cpd/cpd.module').then((m) => m.CpdModule),
                data: { title: 'My CPD Certificates', breadcrumb: 'All Certificates' },
                canLoad: [AuthGuard],
            },
            {
                path: 'legal',
                loadChildren: () => import('./legal-docs/legal-docs.module').then((m) => m.LegalDocsModule),
                data: { title: 'Legal', breadcrumb: 'legal' },
                // canLoad: [AuthGuard],
            },
        ],
    },
    {
        path: '**',
        redirectTo: '/sessions/signin',
    },
];
